import axiosInstance from "../config/axiosInstance";
import API from "../config/config";
import { toast } from "react-toastify";

class TripsMetricsService {
  static async getTripsMetrics(params = {}) {
    try {
      const queryString = new URLSearchParams(params).toString();
      const url = queryString
        ? `${API.ADMIN.RIDES_TRIPS_METRICS}?${queryString}`
        : API.ADMIN.RIDES_TRIPS_METRICS;

      const response = await axiosInstance.get(url);
      return response.data;
    } catch (error) {
      console.error("Error fetching trips metrics:", error);
      toast.error("Failed to fetch trips metrics");
      throw error;
    }
  }
}

export default TripsMetricsService;
